import React, { useEffect, useState } from "react";

function EquipmentInventoryTable({toolData, onAdd = f => f, onRemove = f => f, onUpdateForm = f => f, onDownloadPDF = f => f }) {

  const [equipment, setEquipment] = useState( toolData || []);

  useEffect(() => {
  if (toolData) {
    setEquipment(toolData); 
  }
}, [toolData]);

  const handlePDFDownloadClick = () => {
    onDownloadPDF(toolData) 
  }

  const handleAddSubmit = async (e) => {
    e.preventDefault();
  
    if (!newEquipment.UnitNo || newEquipment.UnitNo.trim() === "") {
      alert("Unit No is required");
      return;
    }
  
    try {
      const equipmentToAdd = {
        UnitNo: newEquipment.UnitNo.trim(),
        SerialNo: newEquipment.SerialNo?.trim() || "N/A",
        Model: newEquipment.Model?.trim() || "N/A",
        Make: newEquipment.Make?.trim() || "N/A",
        Fuel: newEquipment.Fuel?.trim() || "N/A",
        Crew: newEquipment.Crew?.trim() || "N/A",
        Description: newEquipment.Description?.trim() || "N/A",
        Category: newEquipment.Category?.trim() || "N/A",
        SiteLocation: newEquipment.SiteLocation?.trim() || "N/A",
        LastMaintenance: newEquipment.LastMaintenance || new Date().toISOString(),
        Status: newEquipment.Status || "Available"
      };
  
      const result = await onAdd(equipmentToAdd);
      if (result?.success) {
        setShowAddModal(false);
        setNewEquipment({
          UnitNo: "",
          LastMaintenance: new Date().toISOString().split('T')[0],
          Category: "",
          Description: "",
          Crew: "",
          Make: "",
          Fuel: "",
          Model: "",
          SerialNo: "",
          SiteLocation: "",
          Status: "Available"
        });
      } else {
        alert(result.error);
      }
    } catch (error) {
      console.error("Add error:", error);
      alert("Failed to add equipment. See console for details.");
    }
  };
  
  

  // Modal states
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [currentEquipment, setCurrentEquipment] = useState(null);
  
  // Form states
  const [formData, setFormData] = useState({});

  const [newEquipment, setNewEquipment] = useState({
    UnitNo: "",
    Category: "",
    Description: "",
    Crew: "",
    Make: "",
    Fuel: "",
    Model: "",
    SerialNo: "",
    SiteLocation: "",
    Status: "Available",
    LastMaintenance: new Date().toISOString().split('T')[0]
  });

  // Search and filter state
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  // Status color mapping
  const statusColors = {
    'Available': 'bg-green-100 text-green-800',
    'In Use': 'bg-blue-100 text-blue-800',
    'In Repair': 'bg-yellow-100 text-yellow-800',
    'Out of Service': 'bg-red-100 text-red-800',
    'default': 'bg-gray-100 text-gray-800'
  };
  
  // Sort function
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filter and sort equipment
  const filteredEquipment = Array.isArray(equipment) 
  ? equipment
      .filter(item => {
        const matchesSearch = Object.values(item).some(
          val => val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );
        const matchesStatus = statusFilter === "All" || item.Status === statusFilter;
        return matchesSearch && matchesStatus;
      })
      .sort((a, b) => {
        if (!sortConfig.key) return 0;
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      })
  : [];

  const handleUpdateClick = (item) => {
    console.log("=== DEBUG: handleUpdateClick ===");
    console.log("Raw item from DB:", item);
    
    let lastMaintenanceDate;
    if (item.LastMaintenance) {
      const date = new Date(item.LastMaintenance);
      lastMaintenanceDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    } else {
      const now = new Date();
      lastMaintenanceDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    }
  
    const newFormData = { 
      UnitNo: item.UnitNo || "",
      Category: item.Category || "",
      Description: item.Description || "",
      Crew: item.Crew || "",
      Make: item.Make || "",
      Fuel: item.Fuel || "",
      Model: item.Model || "",
      SerialNo: item.SerialNo || "",
      SiteLocation: item.SiteLocation || "",
      Status: item.Status || "Available",
      LastMaintenance: lastMaintenanceDate 
    };
  
    console.log("Complete formData being set:", newFormData);
    
    setCurrentEquipment(item);
    setFormData(newFormData);
    setShowUpdateModal(true);
  };

  const handleDeleteClick = (item) => {
    setCurrentEquipment(item);
    setShowDeleteModal(true);
  };

  const handleAddClick = () => {
    setShowAddModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setNewEquipment(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!currentEquipment) return;
    
    try {
      console.log("=== UPDATE SUBMIT DEBUG ===");
      console.log("Original equipment:", currentEquipment);
      console.log("Form data:", formData);
  
      // let lastMaintenanceISO;
      // if (formData.LastMaintenance) {
      //   const [year, month, day] = formData.LastMaintenance.split('-');
      //   const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
      //   lastMaintenanceISO = date.toISOString();
      // } else {
      //   lastMaintenanceISO = new Date().toISOString();
      // }

      let lastMaintenanceISO = formData.LastMaintenance
      ? new Date(formData.LastMaintenance).toISOString()
      : new Date().toISOString();

      const updateData = {
        _id: currentEquipment._id,
        UnitNo: formData.UnitNo || "",
        Category: formData.Category || "",
        Description: formData.Description || "",
        Crew: formData.Crew || "",
        Make: formData.Make || "",
        Fuel: formData.Fuel || "",
        Model: formData.Model || "",
        SerialNo: formData.SerialNo || "",
        SiteLocation: formData.SiteLocation || "",
        Status: formData.Status || "Available",
        LastMaintenance: lastMaintenanceISO
      };
  
      console.log("Sending to backend:", updateData);
  
      const result = await onUpdateForm(updateData);
      console.log("Backend response:", result);
  
      if (result?.success) {
        console.log("Update successful!");
        setShowUpdateModal(false);
      } else {
        console.error("Update failed:", result?.error);
        alert(`Update failed: ${result?.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error("Update error:", error);
      alert(`Update error: ${error.message}`);
    }
  };

  const handleDeleteConfirm = () => {
    const filteredEquipment = equipment.filter(
      item => item.id !== currentEquipment.id
    );
    onRemove(currentEquipment)
    setEquipment(filteredEquipment);
    setShowDeleteModal(false);
  };

  const columns = [
    { key: 'UnitNo', label: 'Unit No', width: 'w-24' },
    { key: 'Category', label: 'Category', width: 'w-32' },
    { key: 'Description', label: 'Description', width: 'w-48' },
    { key: 'Crew', label: 'Crew', width: 'w-40' },
    { key: 'Make', label: 'Make', width: 'w-32' },
    { key: 'Power', label: 'Power', width: 'w-32' },
    { key: 'Model', label: 'Model', width: 'w-32' },
    { key: 'SerialNo', label: 'Serial No', width: 'w-32' },
    {key: "LastMaintenance", label: "Last Maintenance", width: 'w-31'},
    { key: 'Status', label: 'Status', width: 'w-32' },
    { key: 'SiteLocation', label: 'Location', width: 'w-40' },
    { key: 'Actions', label: 'Actions', width: 'w-32' }
  ];

  return (
    <div className="mx-auto m-10 pt-20 p-4 max-w-screen-2xl">
      {/* Header with search and filters */}
      <div className="mb-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Equipment Inventory</h1>
          <p className="text-gray-600">{equipment.length} items in inventory</p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          <div className="relative">
            <input
              type="text"
              placeholder="Search equipment..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <svg
              className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
          
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="All">All Statuses</option>
            <option value="Available">Available</option>
            <option value="In Use">In Use</option>
            <option value="In Repair">In Repair</option>
            <option value="Out of Service">Out of Service</option>
          </select>
          
          <button
            onClick={handleAddClick}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-medium transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Equipment
          </button>
          <button
            onClick={handlePDFDownloadClick}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg text-white font-medium transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Download PDF
          </button>
        </div>
      </div>

      {/* Equipment Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                {columns.map((column) => (
                  <th
                    key={column.key}
                    className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${column.width} ${
                      column.key !== 'actions' ? 'cursor-pointer hover:bg-gray-100' : ''
                    }`}
                    onClick={() => column.key !== 'actions' && requestSort(column.key)}
                  >
                    <div className="flex items-center">
                      {column.label}
                      {sortConfig.key === column.key && (
                        <span className="ml-1">
                          {sortConfig.direction === 'asc' ? '↑' : '↓'}
                        </span>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredEquipment.length > 0 ? (
                filteredEquipment.map((item) => (
                  <tr key={item._id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">
                      {item.UnitNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.Category}
                    </td>
                    <td className="px-6 py-4 text-gray-700 max-w-xs truncate">
                      {item.Description}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.Crew}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.Make}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.Fuel}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.Model}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.SerialNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                    {item.LastMaintenance 
                      ? new Date(item.LastMaintenance).toLocaleDateString() 
                      : 'N/A'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        statusColors[item.Status] || statusColors.default
                      }`}>
                        {item.Status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-700">
                      {item.SiteLocation}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex space-x-2">
                        <button
                          onClick={() => handleUpdateClick(item)}
                          className="text-blue-600 hover:text-blue-900"
                          title="Edit"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                          </svg>
                        </button>
                        <button
                          onClick={() => handleDeleteClick(item)}
                          className="text-red-600 hover:text-red-900"
                          title="Delete"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="px-6 py-4 text-center text-gray-500">
                    No equipment found matching your criteria
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Equipment Modal */}
      <Modal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        title="Add New Equipment"
      >
        {/* ADD
        -------------------------------------------- */}
      <form onSubmit={handleAddSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Unit No</label>
          <input
            type="text"
            name="UnitNo"
            value={newEquipment.UnitNo}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Category</label>
          <input
            type="text"
            name="Category"
            value={newEquipment.Category}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <input
            type="text"
            name="Description"
            value={newEquipment.Description}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Crew</label>
          <input
            type="text"
            name="Crew"
            value={newEquipment.Crew}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Make</label>
          <input
            type="text"
            name="Make"
            value={newEquipment.Make}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Fuel</label>
          <input
            type="text"
            name="Fuel"
            value={newEquipment.Fuel}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Model</label>
          <input
            type="text"
            name="Model"
            value={newEquipment.Model}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Serial No</label>
          <input
            type="text"
            name="SerialNo"
            value={newEquipment.SerialNo}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Site Location</label>
          <input
            type="text"
            name="SiteLocation"
            value={newEquipment.SiteLocation}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Status</label>
          <select
            name="Status"
            value={newEquipment.Status}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="Available">Available</option>
            <option value="In Use">In Use</option>
            <option value="In Repair">In Repair</option>
            <option value="Out of Service">Out of Service</option>
          </select>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700">Last Maintenance</label>
          <input
            type="date"
            name="LastMaintenance"
            value={newEquipment.LastMaintenance}
            onChange={handleAddInputChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        </div>
        <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={() => setShowAddModal(false)}
          className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 rounded-md text-sm font-medium text-white hover:bg-blue-700"
        >
          Add Equipment
        </button>
        </div>
    </form>
      </Modal>
      {/* --------------------------------
      ADD */}

      {/* UPADATE */}

{/* Update Equipment Modal */}
<Modal
  isOpen={showUpdateModal}
  onClose={() => setShowUpdateModal(false)}
  title="Update Equipment"
>
  <form onSubmit={handleUpdateSubmit}>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Unit No</label>
        <input
          type="text"
          name="UnitNo"
          value={formData.UnitNo || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Category</label>
        <input
          type="text"
          name="Category"
          value={formData.Category || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Description</label>
        <input
          type="text"
          name="Description"
          value={formData.Description || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Crew</label>
        <input
          type="text"
          name="Crew"
          value={formData.Crew || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Make</label>
        <input
          type="text"
          name="Make"
          value={formData.Make || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Fuel</label>
        <input
          type="text"
          name="Fuel"
          value={formData.Fuel || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Model</label>
        <input
          type="text"
          name="Model"
          value={formData.Model || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Serial No</label>
        <input
          type="text"
          name="SerialNo"
          value={formData.SerialNo || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Site Location</label>
        <input
          type="text"
          name="SiteLocation"
          value={formData.SiteLocation || ''}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="space-y-1">
        <label className="block text-sm font-medium text-gray-700">Status</label>
        <select
          name="Status"
          value={formData.Status || 'Available'}
          onChange={handleInputChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="Available">Available</option>
          <option value="In Use">In Use</option>
          <option value="In Repair">In Repair</option>
          <option value="Out of Service">Out of Service</option>
        </select>
      </div>
    <div className="space-y-1">
      <label className="block text-sm font-medium text-gray-700">Last Maintenance</label>
      <input
        type="date"
        name="LastMaintenance"
        value={formData.LastMaintenance || ""}
        onChange={handleInputChange}
        className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
    </div>
    <div className="flex justify-end space-x-3">
      <button
        type="button"
        onClick={() => setShowUpdateModal(false)}
        className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Cancel
      </button>
      <button
        type="submit"
        className="px-4 py-2 bg-blue-600 rounded-md text-sm font-medium text-white hover:bg-blue-700"
      >
        Save Changes
      </button>
    </div>
  </form>
</Modal>
<Modal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="Confirm Deletion"
      >
        <div className="mb-6">
          <p className="text-gray-600">
            Are you sure you want to delete equipment <strong>{currentEquipment?.UnitNo}</strong>? This action cannot be undone.
          </p>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setShowDeleteModal(false)}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteConfirm}
            className="px-4 py-2 bg-red-600 rounded-md text-sm font-medium text-white hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </Modal>
</div>
  );
}

// Reusable Modal Component
function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export default EquipmentInventoryTable;


